import './app.js'
import { imageApplyDataAttr } from './helpers.js'
import SlideShow from './slideshow.js'

const ratio = 1.33
const thumbnails = document.querySelectorAll( 'picture.thumbnail' )

function setSizes()
{
  thumbnails.forEach( thumbnail => {
    const { clientWidth: width } = thumbnail
    thumbnail.style.height = Math.round( width / ratio ) + 'px'
  })
}

//set sizes
setSizes()

//observer
const observer = new IntersectionObserver( entries => {
  entries.forEach( ({ isIntersecting, target }) => {

    if( isIntersecting && !target.classList.contains( 'active' ) )
    {
      const image = target.querySelector( 'img' )

      if( image ){
        imageApplyDataAttr( image, ({ target }) => {
          target.classList.add( 'active' )
        })
      }

      target.classList.add( 'active' )
    }
  })
})

thumbnails.forEach( thumbnail => {
  observer.observe( thumbnail )
})

//event listener
window.addEventListener( 'resize', setSizes )

//slide show init
SlideShow.init( thumbnails )
